import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-video-block',
  templateUrl: './video-block.component.html',
  styleUrls: ['./video-block.component.scss'],
})
export class VideoBlockComponent implements OnInit {
  @Input() title: string;

  @Input() url: string;

  @Input() text: string;

  @Input() position = 'left';

  @Input() bgColor = 'white';

  constructor() {}

  ngOnInit() {}
}
